import React from 'react';
import { ReviewTemplateProps } from '../types';
import StarRating from '../../components/StarRating';
import { formatRecommendationDisplay, getRatingNumber } from '../../utils/formatters';
import { lightenColor } from '../../utils/colorUtils';
import SourceLogo from '../components/SourceLogo';

const ShareReviewTemplate4: React.FC<ReviewTemplateProps> = ({
    reviewerName,
    reviewText,
    rating,
    network,
    color = '#0c4a6e',
    logo,
    showLogo,
    showSource,
}) => {
    const numericRating = getRatingNumber(rating);
    const isFacebookRecommendation =
        network === 'facebook' && (rating === 'positive' || rating === 'negative');

    const lightColor = lightenColor(color, 30);

    return (
        <div
            className="w-[1080px] h-[1080px] p-24 relative rounded-[20px] inline-flex flex-col justify-between items-center overflow-hidden"
            style={{ backgroundColor: color }}
        >
            <div className="flex flex-col gap-10">
                <div className="z-[1000] m-auto rotate-180">
                    <svg
                        width="194"
                        height="112"
                        viewBox="0 0 194 160"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M133.71 81.0323C118.742 74.8387 109.452 61.4193 109.452 42.3225C109.452 17.0322 127.516 -5.73042e-06 150.742 -3.69996e-06C175.516 -1.53413e-06 193.064 17.5484 193.064 42.3226C193.064 54.1935 191 62.9677 181.71 86.7097L154.355 160L113.064 160L133.71 81.0323ZM24.2903 81.0322C9.32252 74.8387 0.0321894 61.4193 0.0321911 42.3225C0.0321933 17.0322 18.0967 -1.52962e-05 41.3225 -1.32657e-05C66.0967 -1.10999e-05 83.6451 17.5484 83.6451 42.3225C83.6451 54.1935 81.5806 62.9677 72.2903 86.7097L44.9354 160L3.64511 160L24.2903 81.0322Z"
                            fill="#fff"
                        />
                    </svg>
                </div>
                <div className="self-stretch flex flex-col justify-start items-start gap-10">
                    <div className="self-stretch flex flex-col justify-start items-center gap-10">
                        <div className="self-stretch text-center justify-start text-white text-[50px] font-semibold font-['Montserrat'] leading-[58.80px]">
                            {reviewText}
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="w-[984px] h-44 pl-14 pr-24 absolute left-[96px] bottom-[288px] rounded-tl-[200px] rounded-bl-[200px] inline-flex justify-between items-center"
                style={{ backgroundColor: lightColor }}
            >
                {isFacebookRecommendation ? (
                    <>
                        <div className="justify-start text-white text-[40px] font-semibold font-['Montserrat'] leading-[42px]">
                            {reviewerName}
                        </div>
                        <div className="flex-1 flex justify-end items-center gap-3">
                            {formatRecommendationDisplay(rating, 'template4')}
                        </div>
                    </>
                ) : (
                    <>
                        <div className="flex items-center">
                            <StarRating
                                rating={numericRating}
                                iconSize={'h-[67px]'}
                                color={'#fff'}
                            />
                        </div>
                        <div className="justify-end text-white text-[40px] font-semibold font-['Montserrat'] leading-[42px]">
                            {reviewerName}
                        </div>
                    </>
                )}
            </div>
            <div
                className={`self-stretch inline-flex items-center z-[1000] ${showLogo && logo && showSource ? 'justify-between' : showLogo && logo ? 'justify-start' : showSource ? 'justify-end' : 'justify-center'}`}
            >
                {showLogo && logo && (
                    <img
                        src={logo}
                        alt="Logo"
                        className="h-24 object-contain"
                        crossOrigin="anonymous"
                    />
                )}
                {showSource && <SourceLogo network={network} template="template1" />}
            </div>
        </div>
    );
};

export default ShareReviewTemplate4;
